// src/pages/NotFound.js
import { Link } from "react-router-dom";
import "./styling/notFound.css";

export default function NotFound() {
  return (
    <main className="nf-page">
      <section className="nf-card">
        <p className="nf-code">404</p>
        <h1>Pagina niet gevonden</h1>
        <p>
          De pagina die je zoekt bestaat niet (meer), of de URL is niet correct.
        </p>

        <div className="nf-actions">
          <Link to="/" className="nf-btn nf-btn-primary">Naar home</Link>
          <Link to="/contact" className="nf-btn nf-btn-secondary">Contact</Link>
        </div>
      </section>
    </main>
  );
}
